import { Reveal, Eyebrow } from "./Shared";

const CHAPTERS = [
  ["Beliefs", "Examine the stories running your decisions around money, visibility, and receiving."],
  ["Identity", "Define the person your vision actually requires — and start practicing being her."],
  ["Why", "Reconnect with the reason beneath the revenue, so the work stops feeling hollow."],
  ["Message", "Find the words only you can say — and say them without watering them down."],
  ["Market", "Identify who needs that message, and why it matters to them right now."],
  ["Offer", "Shape an offer that makes the transformation tangible — not just sellable."],
  ["Action", "Move with intention: small wins, embodied decisions, forward motion."],
];

export default function Path() {
  return (
    <section data-testid="path-section" className="relative py-20 sm:py-32 bg-coal/40 border-y border-cream/5">
      <div className="max-w-6xl mx-auto px-4 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Reveal>
              <Eyebrow>The Blueprint path</Eyebrow>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-display font-extrabold uppercase tracking-tight leading-[0.95] text-3xl sm:text-5xl">
                Seven pieces.{" "}
                <span className="font-serif italic normal-case font-medium text-lime">One direction.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="max-w-xs text-sm leading-relaxed text-fog">
              BLUEPRINT brings every piece of you into the same chapter — in order.
            </p>
          </Reveal>
        </div>

        <div className="mt-12 sm:mt-16 border-t border-cream/10">
          {CHAPTERS.map(([title, desc], i) => (
            <Reveal key={title} delay={i * 0.04} y={18}>
              <div
                data-testid={`path-chapter-${i + 1}`}
                className="group grid grid-cols-[auto,1fr] sm:grid-cols-12 gap-x-5 sm:gap-x-8 gap-y-2 items-baseline py-6 sm:py-8 border-b border-cream/10 transition-colors duration-300 hover:bg-cream/[0.03] sm:px-4"
              >
                <span className="sm:col-span-2 font-display font-extrabold text-3xl sm:text-5xl text-outline group-hover:text-lime group-hover:[-webkit-text-stroke:0] transition-all duration-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="sm:col-span-4 font-display font-bold uppercase tracking-tight text-xl sm:text-2xl">
                  {title}
                </h3>
                <p className="col-span-2 sm:col-span-6 text-sm sm:text-base leading-relaxed text-fog group-hover:text-cream/80 transition-colors duration-300">
                  {desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
